import { render, staticRenderFns } from "./PayPalForm.vue?vue&type=template&id=07a35d38&scoped=true"
import script from "./PayPalForm.vue?vue&type=script&lang=js"
export * from "./PayPalForm.vue?vue&type=script&lang=js"
import style0 from "./PayPalForm.vue?vue&type=style&index=0&id=07a35d38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a35d38",
  null
  
)

export default component.exports